import HttpService from './HttpService'
import configService from './ConfigService'
import ErrorLoggingService from './ErrorLoggingService'

class AuthService {
  checkIdToken () {
    const url = configService.apiGatewayHost() + '/gw/rest/auth/token-refresh-check'
    return HttpService.post(url)
  }

  getCurrentAuths () {
    const url = configService.apiGatewayHost() + '/tenant-api-resource/api-context-dependent/users/current/auths'
    // provide a custom error handler that just logs. We want the originating caller
    // (main.js or guards.js) to catch the error and redirect to the /authorize
    // endpoint with the appropriate callback uri.
    return HttpService.get(url, {
      errorHandler: (err) => {
        // do nothing other than log, promise is rejected in HttpService
        // to allow caller to catch/rethrow etc
        ErrorLoggingService.logError(err)
      }
    })
  }
}

export default new AuthService()
